import React, { useEffect } from 'react';

const MaintenancePage = () => {
  useEffect(() => {
    document.title = '503 Temporary Server Error';
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement('meta');
      robots.setAttribute('name', 'robots');
      document.head.appendChild(robots);
    }
    robots.setAttribute('content', 'noindex, nofollow');
  }, []);

  return (
    <div
      className="min-h-screen bg-white flex items-center justify-center px-4"
      data-testid="maintenance-page"
    >
      <h1 className="text-2xl md:text-3xl font-semibold text-gray-900 text-center">
        503 Temporary Server Error
      </h1>
    </div>
  );
};

export default MaintenancePage;
